var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-pagination',{attrs:{"background":"","small":_vm.small,"layout":_vm.layout,"total":_vm.total,"page-size":_vm.pageSize,"page-sizes":_vm.pageSizes,"current-page":_vm.pageNum,"pager-count":_vm.pagerCount},on:{"size-change":_vm.sizeChange,"current-change":_vm.currentChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }